{
  "title": "Dispel Evil and Good",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level abjuration",
  "level": 5,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (holy water or powdered silver and iron)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "Shimmering energy surrounds and protects you from fey, undead, and creatures originating from beyond the Material Plane. For the duration, celestials, elementals, fey, fiends, and undead have disadvantage on attack rolls against you. You can end the spell early by using either of the following special functions.",
    "Break Enchantment. As your action, you touch a creature you can reach that is charmed, frightened, or possessed by a celestial, an elemental, a fey, a fiend, or an undead. The creature you touch is no longer charmed, frightened, or possessed by such creatures.",
    "Dismissal. As your action, make a melee spell attack against a celestial, an elemental, a fey, a fiend, or an undead you can reach. On a hit, you attempt to drive the creature back to its home plane. The creature must succeed on a Charisma saving throw or be sent back to its home plane (if it isn’t there already). If they are already on their home plane, undead are sent to the Shadowfell, and fey are sent to the Feywild."
  ],
  "spellLists": ["cleric", "paladin"]
}
